import Login from "../../pages/admin/auth/Login";
import AdminContent from "../../pages/admin/content";
import Events from "../../pages/admin/events";
import BootcampDetail from "../../pages/admin/events/BootcampDetail";
import CreateNuterra from "../../pages/admin/events/nuterra-wellness/CreateNuterra";
import EditNuterraDetails from "../../pages/admin/events/nuterra-wellness/EditNuterraDetails";
import NuterraDetails from "../../pages/admin/events/nuterra-wellness/NuterraDetails";
import WebinarDetail from "../../pages/admin/events/webinar/WebinarDetail";
import WorkShopDetails from "../../pages/admin/events/workshop/WorkShopDetails";
import Inbox from "../../pages/admin/Inbox";
import InviteProject from "../../pages/admin/InviteProject";
// import InviteFreelancer from "../../pages/admin/InviteFreelancer";
import JobProjects from "../../pages/admin/project";
import Services from "../../pages/admin/services";
import Users from "../../pages/admin/users";
import AddWebinar from "../../pages/common/webinar/AddWebinar";
import UpdateWebinar from "../../pages/common/webinar/UpdateWebinar";
import AddWorkshpoDetails from "../../pages/common/workshop";
import UpdateAdminWorkshop from "../../pages/common/workshop/UpdateAdminWorkshop";

export const adminPaths = {
  Login: "/admin/login",
  Users: "/admin/users",
  Events: "/admin/events",
  Services: '/admin/services',
  BootcampDetail: "/admin/bootcamp-detail",
  UpdateWebinar: "/admin/update-webinar",
  AddWebinar: "/admin/add-webinar",
  WebinarDetail: "/admin/webinar-detail",
  AddWorkshop: "/admin/add-workshop",
  WorkShopDetails: "/admin/workShopDetails",
  UpdateWorkshopData: "/admin/update-workshop",
  AdminContent: "/admin/content",
  CreateNuterra: "/admin/create-nuterra-wellness",
  NuterraDetails: "/admin/nuterra-details",
  EditNuterraDetails: "/admin/edit-nuterra-details",
  JobProject: "/admin/project",
  // Inbox: "/admin/inbox",
  InviteProject: "/admin/invite-project",
};

export const AllAdminRoutes = [
  {
    name: "Login",
    path: adminPaths.Login,
    element: <Login />,
    isPrivate: false,
  },
  {
    name: "Users",
    path: adminPaths.Users,
    element: <Users />,
    isPrivate: false,
  },
  {
    name: "Events",
    path: adminPaths.Events,
    element: <Events />,
    isPrivate: false,
  },
  {
    name: "Services",
    path: adminPaths.Services,
    element: <Services />,
    isPrivate: false,
  },
  {
    name: "Job Project",
    path: adminPaths.JobProject,
    element: <JobProjects />,
    isPrivate: false,
  },
  {
    name: "BootcampDetail",
    path: adminPaths.BootcampDetail,
    element: <BootcampDetail />,
    isPrivate: false,
  },
  {
    name: "AddWebinar",
    path: adminPaths.AddWebinar,
    element: <AddWebinar />,
    isPrivate: false,
  },
  {
    name: "Update Work shop Data",
    path: adminPaths.UpdateWorkshopData,
    element: <UpdateAdminWorkshop />,
    isPrivate: false,
  },
  {
    name: "UpdateWebinar",
    path: adminPaths.UpdateWebinar,
    element: <UpdateWebinar />,
    isPrivate: false,
  },
  {
    name: "WebinarDetail",
    path: adminPaths.WebinarDetail,
    element: <WebinarDetail />,
    isPrivate: false,
  },
  {
    name: "Add Workshop Details",
    path: adminPaths.AddWorkshop,
    element: <AddWorkshpoDetails />,
    isPrivate: false,
  },
  {
    name: "Work Shop Details",
    path: adminPaths.WorkShopDetails,
    element: <WorkShopDetails />,
    isPrivate: false,
  },
  {
    name: "Admin Content",
    path: adminPaths.AdminContent,
    element: <AdminContent />,
    isPrivate: false,
  },
  {
    name: "CreateNuterra",
    path: adminPaths.CreateNuterra,
    element: <CreateNuterra />,
    isPrivate: false,
  },
  {
    name: "NuterraDetails",
    path: adminPaths.NuterraDetails,
    element: <NuterraDetails />,
    isPrivate: false,
  },
  {
    name: "EditNuterraDetails",
    path: adminPaths.EditNuterraDetails,
    element: <EditNuterraDetails />,
    isPrivate: false,
  },
  {
    name: "InviteProject",
    path: adminPaths.InviteProject,
    element: <InviteProject />,
    isPrivate: false,
  },
  // {
  //   name: "Inbox",
  //   path: adminPaths.Inbox,
  //   element: <Inbox />,
  //   isPrivate: false,
  // },
];